import React from 'react';
import ComingSoonPage from '../components/ComingSoonPage';
import { Sofa, Coffee, Maximize } from 'lucide-react';

const HomeLivingLandingPage = () => {
  const features = [
    {
      icon: <Sofa size={20} />,
      title: "Cylindrical Warping",
      description: "Perfectly wrap designs around mugs, tumblers, and candles."
    },
    {
      icon: <Coffee size={20} />,
      title: "Texture Mapping",
      description: "Realistic ceramic, glass, and fabric textures automatically applied."
    },
    {
      icon: <Maximize size={20} />,
      title: "Scene Generation",
      description: "Place your products on coffee tables, desks, and shelves."
    }
  ];

  return (
    <ComingSoonPage 
      title="Home & Living Generator"
      subtitle="Create stunning mockups for mugs, pillows, and wall art. We are currently training our physics engine for cylindrical warping."
      progress={85}
      statusText="Fine-tuning Physics Engine..."
      toolId="home-living"
      features={features}
    />
  );
};

export default HomeLivingLandingPage;